import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userReducer';
import billingReducer from './billingReducer';

export const rootReducer = combineReducers({
    user: userReducer,
    billing: billingReducer,
});
